export default __webpack_public_path__ + "static/media/imgKip1.668d6413.png";